module.exports = __webpack_public_path__ + "static/media/Thoma.9d753f7c.png";